var identifier = '[^\\s\\(\\)]+';
var binding = "((".concat(identifier, ")(\\((").concat(identifier, ")\\))?->)?(").concat(identifier, ")");
var regExp = new RegExp(binding, 'g');
var captureIndicies = {
  id: 0,
  event: 2,
  mode: 4,
  motion: 5
};
export var MODE_LISTEN = 'listen';
export var MODE_HANDLE = 'handle';
var DEFAULT_EVENT = {
  _other: 'click',
  FORM: 'submit',
  INPUT: function INPUT(_ref) {
    var type = _ref.type;
    return type === 'submit' ? 'click' : 'change';
  },
  SELECT: 'change',
  TEXTAREA: 'change'
};
var DEFAULT_MODE = {
  _other: MODE_HANDLE,
  change: MODE_LISTEN
};
export default function parseBindings(input, element) {
  if (!input) {
    return [];
  }

  return Array.from(input.matchAll(regExp), function (match) {
    var id = match[captureIndicies.id];
    var motion = match[captureIndicies.motion];
    var event = match[captureIndicies.event] || defaultEventFor(element);
    var mode = match[captureIndicies.mode] || defaultModeFor(event);
    return {
      id: id,
      motion: motion,
      event: event,
      mode: mode
    };
  });
}

function defaultEventFor(element) {
  var event = DEFAULT_EVENT[element && element.tagName] || DEFAULT_EVENT._other;

  if (typeof event === 'function') {
    return event(element);
  } else {
    return event;
  }
}

function defaultModeFor(event) {
  return DEFAULT_MODE[event] || DEFAULT_MODE._other;
}